import {Component, Input, OnInit} from '@angular/core';
import {PublicationModel} from '../../../models/publication.model';

@Component({
    selector: 'app-isbn-report-table',
    templateUrl: './isbn-report-table.component.html',
    styleUrls: ['./isbn-report-table.component.scss']
})
export class IsbnReportTableComponent implements OnInit {
    pTable = {
        colNumber: 6,
        expandedRows: {}
    };

    @Input('filteredPublication')
    filteredPublication: PublicationModel[] = [];
    selectedPublication: PublicationModel[] = [];
    @Input() totalItems = 0;

    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/+app-custom/components/generate-report/isbn-report-table/isbn-report-table.component.ts